var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails = function SvgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.637 9.997H7.97M10.637 7.33H7.97M10.637 4.663H7.97",
    stroke: "#697077",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7.852 13.925-2.22-1.11a.665.665 0 0 0-.595 0l-1.886.944a.333.333 0 0 1-.483-.298V2.667c0-.368.299-.667.667-.667h9.333c.368 0 .667.299.667.667V13.46c0 .248-.261.408-.483.298l-1.886-.944a.665.665 0 0 0-.596 0l-2.22 1.11a.331.331 0 0 1-.298 0v0Z",
    stroke: "#697077",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.303 10.004c.002 0 .004-.001.004-.003s-.002-.004-.004-.004-.003.002-.003.004.001.003.003.003M5.303 7.336c.002 0 .004-.001.004-.003s-.002-.004-.004-.004-.003.002-.003.004.001.003.003.003M5.303 4.67c.002 0 .004-.001.004-.003s-.002-.004-.004-.004-.003.002-.003.004.001.003.003.003",
    stroke: "#697077",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDetails;